(function () {
  const bar = document.querySelector(".sad-progress__bar");
  if (!bar) return;

  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function update() {
    const doc = document.documentElement;
    const scrollTop = doc.scrollTop || document.body.scrollTop;
    const scrollHeight = (doc.scrollHeight || document.body.scrollHeight) - doc.clientHeight;
    const progress = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
    bar.style.width = progress.toFixed(2) + "%";
  }

  if (prefersReduced) {
    update();
    window.addEventListener("scroll", update, { passive: true });
    return;
  }

  let ticking = false;
  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  update();
})();